import { render } from "./CadastroUsuario.vue?vue&type=template&id=57e37c8e&scoped=true"
import script from "./CadastroUsuario.vue?vue&type=script&lang=js"
export * from "./CadastroUsuario.vue?vue&type=script&lang=js"

import "./CadastroUsuario.vue?vue&type=style&index=0&id=57e37c8e&scoped=true&lang=css"
import "@vueform/multiselect/themes/default.css?vue&type=style&index=1&lang=css"

import exportComponent from "/opt/vue/ped/ped-ui/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-57e37c8e"]])

export default __exports__